angular
  .module("myApp")

  .controller("MaksajumiMgrListController", function MaksajumiMgrListController($scope, $state) {
    $scope.view = "maksajuma_pieteikums_mgr_list"
    $scope.gridOptions = {
      filtersUrl: "pages/mp/mp-mgr-filter.html",
      defaultFilters: {},
      initialFilters: {},
      noDataLabel: "Nav atrasts neviens pieteikums.",
      rowClick: (row) => $state.go("app.mp.edit", { id: row.id }),
    }

    if ($state.current.name === "app.maksajumi.list") {
      $scope.gridOptions.filtersUrl = "pages/filter-text.html"
      $state.params.key = "app.maksajumi.list"
      $state.params.initialFilters = {
        flt_mine: false,
        flt_lzp: false,
        flt_iesniegts: true,
        flt_noraidits: false,
        flt_apstiprinats: false,
      }
    }

    if ($state.current.name === "app.maksajumi.list-all") {
      // iesniegtie
      $state.params.key = "app.maksajumi.list-all"
      $state.params.initialFilters = {
        flt_melnraksts: true,
        flt_iesniegts: true,
        flt_izskatisana: true,
        flt_izskatits: true,
        flt_neaktuals: true,
        flt_lzp_ok: true,
        flt_samaksats: true,
      }
    }
    $scope.foo = $state.params
  })
